import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Bot } from 'lucide-react';
import { articulos, data, estadisticasElectorado, perfilesCandidatos, videos } from './data';

// Import refactored components
import Header from './components/Header';
import Home from './components/Home';
import Candidatos from './components/Candidatos';
import ChatAsistente from './components/ChatAsistente';
import Propuestas from './components/Propuestas';
import Datos from './components/Datos';
import AcercaDe from './components/AcercaDe';

function App() {
  const [activeTab, setActiveTab] = useState('inicio');
  const [activo, setActivo] = useState(() => data?.[0] ?? null);
  const [isChatOpen, setIsChatOpen] = useState(false);

  const navItems = [
    { id: 'inicio', label: 'Inicio' },
    { id: 'candidatos', label: 'Candidatos' },
    { id: 'propuestas', label: 'Propuestas' },
    { id: 'datos', label: 'Datos' },
    { id: 'acerca', label: 'Acerca de' }
  ];

  const renderActiveSection = () => {
    switch (activeTab) {
      case 'inicio':
        return (
          <Home
            setActiveTab={setActiveTab}
            perfilesCandidatos={perfilesCandidatos}
          />
        );
      case 'candidatos':
        return <Candidatos perfilesCandidatos={perfilesCandidatos} />;
      case 'propuestas':
        return (
          <Propuestas
            activo={activo}
            setActivo={setActivo}
            data={data}
          />
        );
      case 'datos':
        return (
          <Datos
            articulos={articulos}
            videos={videos}
            estadisticasElectorado={estadisticasElectorado}
          />
        );
      case 'acerca':
        return <AcercaDe />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-[#f8fafc] font-sans text-slate-900">
      <Header
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        activo={activo}
        setActivo={setActivo}
        navItems={navItems}
        data={data}
        perfilesCandidatos={perfilesCandidatos}
      />

      <main>
        <AnimatePresence mode="wait">
          {renderActiveSection()}
        </AnimatePresence>
      </main>

      {/* Floating chatbot AI button */}
      <div className="fixed bottom-4 right-4 z-40 sm:bottom-6 sm:right-6 group">
        <button
          type="button"
          aria-label="Asistente de IA"
          onClick={() => setIsChatOpen(true)}
          className="relative flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 text-white shadow-xl transition-transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2"
        >
          <Bot className="h-7 w-7" />
          <span className="pointer-events-none absolute bottom-full right-0 mb-3 w-max max-w-[14rem] rounded-2xl bg-slate-900 px-3 py-2 text-[11px] font-medium leading-snug text-white opacity-0 shadow-lg transition-all duration-200 group-hover:opacity-100 group-focus-within:opacity-100">
            Pregúntale a la IA sobre los candidatos
            <span className="absolute -bottom-1 right-4 h-2 w-2 rotate-45 bg-slate-900" />
          </span>
        </button>
      </div>

      <ChatAsistente
        open={isChatOpen}
        onClose={() => setIsChatOpen(false)}
      />
    </div>
  );
}

export default App;
